/**
*
* DesktopContainer
*
*/

import styled from 'styled-components';
import { media } from 'style-utils';
import { KIOSK } from 'Application/constants';
import { isTouchEnabled } from 'utils/kiosk';

const DesktopContainer = styled.div`
  ${media.desktop`
    max-width: ${({ theme }) => theme.applicationMode === KIOSK && !isTouchEnabled ? '1060px;' : '1180px;'}
    margin: 0 auto;
  `}
`;

export default DesktopContainer;

export const PaddedDesktopContainer = styled(DesktopContainer)`
  /* Remove horizontal scroll in mobile due to swiper arrows margin/padding */
  ${({ theme }) => theme.applicationMode === KIOSK ? '' : 'overflow: hidden;'}

  /* Compensate swiper arrows margin */
  ${media.desktop`
    padding: 0 60px;
  `}
`;
